import React from 'react';
import './ProgressBar.scss';
export var ProgressBarMobile = function (_a) {
    var index = _a.index, completed = _a.completed, barHeight = _a.barHeight;
    if (!index) {
        return (React.createElement(ProgressBarMobileTopper, { progressPixels: "".concat((completed / 100) * 19, "px") }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginTop: "-".concat(barHeight - 12, "px") }, className: "ProgressBarMobile__Section sui-flex sui-flex-col sui-justify-start sui-align-center" },
            React.createElement("div", { style: {
                    height: "".concat(barHeight, "px"),
                }, className: "ProgressBarMobile__Container sui-flex sui-flex-col sui-justify-start sui-align-start" },
                React.createElement("div", { style: {
                        marginBottom: '1px',
                        height: "".concat((completed / 100) * (barHeight + 1), "px"),
                    }, className: "ProgressBarMobile" })))));
};
export var ProgressBarMobileTopper = function (_a) {
    var progressPixels = _a.progressPixels;
    return (React.createElement("div", { className: "ProgressBarMobile__Section sui-flex sui-flex-col sui-justify-start sui-align-center" },
        React.createElement("div", { className: "ProgressBarMobile__Topper" }),
        React.createElement("div", { className: "ProgressBarMobile__ContainerFirst" },
            React.createElement("div", { style: { height: progressPixels }, className: "ProgressBarMobile" }))));
};
export var ProgressBarMobileLast = function () { return (React.createElement("div", { className: "ProgressBarMobile__Section sui-flex sui-flex-col sui-justify-start sui-align-center" },
    React.createElement("div", { className: "ProgressBarMobile__ContainerLast" }))); };
